import { render, staticRenderFns } from "./phoneNew.vue?vue&type=template&id=412302c2&scoped=true"
import script from "./phoneNew.vue?vue&type=script&lang=js"
export * from "./phoneNew.vue?vue&type=script&lang=js"
import style0 from "./phoneNew.vue?vue&type=style&index=0&id=412302c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412302c2",
  null
  
)

export default component.exports